import Select from 'components/Select'
import StatesAndProvinces from 'components/StatesDropdown/StatesAndProvinces'


const StatesDropdown = (props) => (
  <Select
    {...props}
    label="State"
    selectOptions={[
      [{ value: '', name: '' }],
      { label: 'USA', options: StatesAndProvinces.US_STATES },
      { label: 'Canada', options: StatesAndProvinces.CAN_PROVINCES }
    ]}
  />
)

export default StatesDropdown
